module.exports = __webpack_public_path__ + "img/thumbsdown.bc190070.svg";